import { isProduction } from './env/process';
/* istanbul ignore next */

if (!isProduction()) {
  if (typeof window.manomano === 'undefined') {
    window.manomano = {};
  }

  window.manomano.featureFlags_abTests = {
    ...(window.manomano.featureFlags_abTests || {}),
    'ff.checkout.address.form.react': 'ON',
  };
}

const splitABTestsAndFeatureFlags = (source = {}) => {
  const abTests = {};
  const featureFlags = {};

  Object.keys(source).forEach(key => {
    if (key.startsWith('ff.')) {
      featureFlags[key] = source[key];
    } else {
      abTests[key] = source[key];
    }
  });

  return { abTests, featureFlags };
};

export { splitABTestsAndFeatureFlags };
